import { render, staticRenderFns } from "./catalog-marks.vue?vue&type=template&id=88eef1d6"
import script from "./catalog-marks.vue?vue&type=script&lang=js"
export * from "./catalog-marks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MakesItemPopular: require('/var/www/components/makes/makes-item-popular.vue').default,ButtonTypical: require('/var/www/components/button/button-typical.vue').default})
